import classNames from 'classnames'
import React from 'react'

export class DropdownMenu extends React.Component<
  DropdownMenuProps,
  DropdownMenuState
  > {
  static defaultProps = {
    openOnClick: false,
    openOnFocus: true,
    openOnHover: false,
    closeOnBlur: true,
    position: 'left',
    scrolling: false,
  }

  state = {
    open: false,
  }

  constructor(props) {
    super(props)
  }

  handleInteraction = event => {
    event.preventDefault()
    const { type, currentTarget } = event
    switch (type) {
      case 'click':
        // Focus helper to handle Safari focus bug https://stackoverflow.com/questions/35552758/css-safari-elementelement-selector-on-focus-bug
        if (this.props.openOnFocus) {
          if (this.state.open) {
            currentTarget.focus()
          }
        }
        if (this.props.openOnClick) {
          this.toggle(!this.state.open, currentTarget)
        }
        break
      case 'mouseEnter':
        if (this.props.openOnHover) {
          this.toggle(true, currentTarget)
        }
        break
      case 'mouseLeave':
        if (this.props.openOnHover) {
          this.toggle(false, currentTarget)
        }
        break
      case 'focus':
        if (this.props.openOnFocus) {
          this.toggle(true, currentTarget)
        }
        break
      case 'blur':
        if (this.props.closeOnBlur) {
          this.toggle(false, currentTarget)
        }
        break
    }
  }

  toggle = (open: boolean, buttonElement: HTMLElement) => {
    this.setState({ open }, () => {
      if (open) {
        buttonElement.focus()
      } else {
        buttonElement.blur()
      }
    })
  }

  render() {
    const {
      position,
      scrolling,
      buttonContent,
      children,
      classname,
      buttonClassname,
      containerClassname,
    } = this.props
    const dropdownClasses = classNames(
      'DropdownMenu',
      this.state.open && 'DropdownMenu--open',
      position.includes('right') && 'DropdownMenu--right',
      position.includes('above') && 'DropdownMenu--above',
      scrolling && 'DropdownMenu--scrolling',
      classname,
    )
    const containerClasses = classNames(
      'DropdownMenu__container',
      containerClassname,
    )
    return (
      <div className={dropdownClasses}>
        <button
          className={classNames('DropdownMenu__button', buttonClassname)}
          onClick={this.handleInteraction}
          onMouseEnter={this.handleInteraction}
          onMouseLeave={this.handleInteraction}
          onFocus={this.handleInteraction}
          onBlur={this.handleInteraction}
        >
          {buttonContent}
        </button>
        <div className={containerClasses}>{children}</div>
      </div>
    )
  }
}

type DropdownMenuProps = {
  openOnClick?: boolean,
  openOnFocus?: boolean,
  openOnHover?: boolean,
  closeOnBlur?: boolean,
  position?: 'left' | 'right' | 'left above' | 'right above',
  scrolling?: boolean,
  buttonContent: React.ReactNode,
  children: React.ReactElement<any>,
  classname?: string,
  buttonClassname?: string,
  containerClassname?: string,
}

type DropdownMenuState = {
  open: boolean,
}

export default DropdownMenu
